import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Form, Button } from '@enterprise-ui/canvas-ui-react';
import EnterpriseIcon, { ChevronLeftIcon, ChevronRightIcon, CancelIcon, CalendarIcon } from '@enterprise-ui/icons';
import React from 'react';
import { checkToday, checkSameDate } from '../utils/utility.js';

var _excluded = ["changeEvent", "data-testid", "disabled", "disableDates", "externalError", "highlight", "hintText", "id", "internalError", "isCalendarVisible", "label", "onClear", "placeholder", "required", "selectDate", "selectedDate", "setIsCalendarVisible"];
function RawInputField(_ref) {
  var changeEvent = _ref.changeEvent,
    dataTestId = _ref['data-testid'],
    disabled = _ref.disabled,
    disableDates = _ref.disableDates,
    externalError = _ref.externalError,
    highlight = _ref.highlight,
    hintText = _ref.hintText,
    id = _ref.id,
    internalError = _ref.internalError,
    isCalendarVisible = _ref.isCalendarVisible,
    label = _ref.label,
    onClear = _ref.onClear,
    placeholder = _ref.placeholder,
    required = _ref.required,
    selectDate = _ref.selectDate,
    selectedDate = _ref.selectedDate,
    setIsCalendarVisible = _ref.setIsCalendarVisible,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  delete otherProps.onUpdate; //don't pass onUpdate through to Input
  var date = selectedDate ? selectedDate : '';
  var maxExceptDate = disableDates !== null && disableDates !== void 0 && disableDates.except ? disableDates.except.reduce(function (a, b) {
    return a > b ? a : b;
  }) : undefined;
  var minExceptDate = disableDates !== null && disableDates !== void 0 && disableDates.except ? disableDates.except.reduce(function (a, b) {
    return a < b ? a : b;
  }) : undefined;
  var disableBack = isCalendarVisible && ((disableDates === null || disableDates === void 0 ? void 0 : disableDates.past) && checkToday(date) || (disableDates === null || disableDates === void 0 ? void 0 : disableDates.before) && checkSameDate(date, disableDates === null || disableDates === void 0 ? void 0 : disableDates.before) || minExceptDate && checkSameDate(date, minExceptDate));
  var disableForward = isCalendarVisible && ((disableDates === null || disableDates === void 0 ? void 0 : disableDates.future) && checkToday(date) || maxExceptDate && checkSameDate(date, maxExceptDate));
  var handleOnClear = function handleOnClear() {
    onClear();
    setIsCalendarVisible(false);
  };
  var handleSelectDateControls = function handleSelectDateControls(type) {
    selectDate(type);
    setIsCalendarVisible(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "C-DatePicker__Input"
  }, /*#__PURE__*/React.createElement(Form.Field, _extends({}, otherProps, {
    disabled: disabled,
    error: internalError.error || externalError.error,
    errorText: internalError.error ? internalError.errorText : externalError.errorText,
    highlight: highlight,
    hintText: hintText,
    id: id,
    label: label,
    onFocus: function onFocus() {
      setIsCalendarVisible(true);
    },
    "aria-live": "polite",
    onChange: changeEvent,
    placeholder: placeholder,
    required: required,
    value: date,
    "data-testid": dataTestId ? "".concat(dataTestId, "_formfield") : null,
    className: disableDates !== null && disableDates !== void 0 && disableDates.past ? 'disableDates' : null
  })), /*#__PURE__*/React.createElement("span", {
    className: "C-DatePicker__MonthIcons"
  }, isCalendarVisible ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    iconOnly: true,
    size: "dense",
    "data-test": "prevButton",
    "aria-label": "previous day",
    onClick: function onClick() {
      return handleSelectDateControls('prev');
    },
    disabled: disabled || disableBack,
    "data-testid": dataTestId && "".concat(dataTestId, "_previousDay"),
    className: "C-DatePicker__NavButton --embeddedInComponent"
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    icon: ChevronLeftIcon,
    size: 'inline'
  })), /*#__PURE__*/React.createElement(Button, {
    iconOnly: true,
    size: 'dense',
    "data-test": "nextButton",
    "data-testid": dataTestId && "".concat(dataTestId, "_nextDay"),
    "aria-label": "next day",
    onClick: function onClick() {
      return handleSelectDateControls('next');
    },
    disabled: disabled || disableForward,
    className: "C-DatePicker__NavButton --embeddedInComponent"
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    icon: ChevronRightIcon,
    size: 'inline'
  })), /*#__PURE__*/React.createElement(Button, {
    iconOnly: true,
    size: "dense",
    className: "C-DatePicker__NavButton --embeddedInComponent",
    disabled: disabled,
    "data-testid": dataTestId && "".concat(dataTestId, "_clearInput"),
    "data-test": "calendarButton",
    "aria-label": "clear input",
    onClick: handleOnClear
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    icon: CancelIcon,
    size: 'inline'
  }))) : /*#__PURE__*/React.createElement(Button, {
    iconOnly: true,
    size: 'dense',
    className: "C-DatePicker__NavButton --embeddedInComponent",
    disabled: disabled,
    "data-testid": dataTestId && "".concat(dataTestId, "_openCalendar"),
    "data-test": "clearButton",
    "aria-label": "open calendar",
    onClick: function onClick() {
      return setIsCalendarVisible(true);
    }
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    icon: CalendarIcon,
    size: 'inline'
  }))));
}
RawInputField.displayName = 'InputField';
var InputField = /*#__PURE__*/React.memo(RawInputField);

export { InputField as default };
